import {PIC_TYPE,VIDEO_TYPE} from "../../../constants";
import { permissionCheck } from '../../../utils';

export const taskConfig = {
    "createTask": {
        "param": {
            "num": 1,
            "size": 10,
            "keyword": '',
            // "keywordFiled": ["title", "publisher.userName", "taskReporterObjs.reporter.name"],
            // "showRef": [
            //     "taskReporterIds", "clueId", "topicSelectionId"
            // ],
            // "params":[
            //     {
            //         "type": "or",
            //         "params": [
            //             {
            //                 "key": "status",
            //                 "opt": "ne",
            //                 "val": "草稿"
            //             },
            //             {
            //                 "type": "and",
            //                 "params": [
            //                     {
            //                         "key": "status",
            //                         "opt": "eq",
            //                         "val": "草稿"
            //                     },
            //                     {
            //                         "key": "publisher.id",
            //                         "opt": "eq",
            //                         "val": "${window.top.currentUser.id}"
            //                     }
            //                 ]
            //             }
            //         ]
            //     }
            // ]
        },
        "url": '/cm-sites-business/bd/busTask/page',
        "columns": [
            {
                "title": '任务名称',
                "dataIndex": 'title',
                "ellipsis": true,
                "width":380,
                "renderComponent": "${renderExtend.normalTitle}"
            },
            {
                "title": '任务地点',
                "dataIndex": 'place',
                "ellipsis": true,
                "width":100,
                "renderComponent": "${renderExtend.normalTitle}"
            },
            {
                "title": '创建时间',
                "dataIndex": 'createTime',
                "renderComponent": "${renderExtend.taskTime}"
            },
            {
                "title": '任务时间',
                "dataIndex": 'startTime',
                "width": 300,
                "ellipsis": true,
                "renderComponent": "${renderExtend.InterviewTime}"
            },
            {
                "title": '状态',
                "dataIndex": 'status',
                "renderComponent": "${renderExtend.normalStatus}"

            },
            {
                "title": '操作',
                "dataIndex": 'address',
                "renderComponent": "${renderExtend.normalOperation}"
            }
        ],
        "listOpBtns": [
            {
                "name": "查看",
                "condition": [
                    "已提交",
                    "进行中",
                    "已完成",
                    "未领取"
                ],
                "onOk": "${component.view}"
            },
            {
                "name": "修改",
                "auth": "interviewTask_creator",
                "condition": [
                    "已提交",
                    "进行中",
                    "草稿",
                    "未领取"
                ],
                "onOk": "${component.edit}"
            },
            {
                "name": "删除",
                "condition": [
                    "草稿",
                ],
                "onOk": "${component.delete}",
            },
        ],
        "tabList": [
            {
                "name": '全部', 
                "id": "0",
                "auth": ["interview_allList","interview_userList"],
            },
            {
                "name": '已提交', 
                "id": "3",
                "auth": ["interview_allSubmitList","interview_userSubmitList"],
            }, 
            {
                "name": '已完成', 
                "id": "4",
                "auth": ["interview_allCompleteList","interview_userCompleteList"],
            }, 
            {
                "name": '进行中',
                "id": "2",
                "auth": ["interview_allProgressList","interview_userProgressList"],
            }, 
            {
                "name": '未领取', 
                "id": "1",
                "auth": ["interview_allUnReceiveList","interview_userUnReceiveList"],
            },
            {
                "name": '草稿',
                "id": "5",
                "auth": ["interview_tempList",],
            }
        ],
        TableList: [
            {
                id: 0,
                name: '任务信息',
                button: [
                    {
                        name: '取消',
                        type: '',
                        onOk: (component)=>{
                            component.close()
                        },
                        conditionFun:(record, currentUser)=>{
                            return true
                        },
                    },
                    {
                        name: '修改',
                        type: 'primary',
                        // condition:["未领取","已领取","进行中","已提交"],
                        onOk: (component)=>{
                            component.edit(component.state.data.id)
                        },
                        conditionFun:(record, currentUser,status)=>{
                            const condition = ["未领取","已领取","进行中","已提交"];
                            if (permissionCheck('interviewTask_creator') && condition.indexOf(status) !== -1) {
                                return true;
                            }
                            return false;
                        },
                    }, {
                        name: '修改状态',
                        type: 'primary',
                        component: "menuButton",
                        conditionFun:(record, currentUser)=>{
                            if (permissionCheck('interviewTask_creator')) {
                                return true;
                            }
                            return false;
                        },
                        btnList:[{
                            name: '进行中',
                            type: 'primary',
                            onOk: (component)=>{
                                component.modify(component.state.data,"进行中")
                            },
                        },{
                            name: '已提交',
                            type: 'primary',
                            onOk: (component)=>{
                                component.modify(component.state.data,"已提交")
                            },
                        },{
                            name: '已完成',
                            type: 'primary',
                            onOk: (component)=>{
                                component.modify(component.state.data,"已完成")
                            },

                        }
                        ]
                    },
                    {
                        name: '领取任务',
                        type: 'primary',
                        onOk: (record)=>{
                            let data  = record.state.data&&record.state.data.taskReporterObjs?record.state.data.taskReporterObjs:[];
                            let  myRole=data.filter(item=>(item.reporter.name==window.currentUser.name && item.reporter.account==window.currentUser.account&&item.reporter.currentDept?.id===window.currentUser.defaultInfo?.dept?.id));
                             record.receiveTask(myRole)
                        },
                        conditionFun:(record, currentUser)=>{
                            if (!permissionCheck("interview_accept")) {
                                return false;
                            }
                            let data  = record.state.data&&record.state.data.taskReporterObjs?record.state.data.taskReporterObjs:[]
                            let  myRole=data.filter(item=>(item.reporter.name==currentUser.name && item.reporter.account==currentUser.account&&item.reporter.currentDept?.id=== currentUser.defaultInfo?.dept?.id));
                            if(myRole&&myRole.length&&myRole[0].status==='未领取'){
                                return true
                            }else{
                                return false
                            }
                        },
                    },
                    {
                        name: '去写稿',
                        type: 'primary',
                        conditionFun:(record, currentUser)=>{
                            if (!permissionCheck("interview_accept")) {
                                return false;
                            }
                            let data  = record.state.data&&record.state.data.taskReporterObjs?record.state.data.taskReporterObjs:[];
                            let  myRole=data.filter(item=>(item.reporter.name==currentUser.name && item.reporter.account==currentUser.account&&item.reporter.currentDept?.id=== currentUser.defaultInfo?.dept?.id));
                            if(myRole&&myRole.length&&myRole[0].taskRole.indexOf('文字记者')>-1 && myRole[0].status!=='未领取' && myRole[0].status!=='已完成'){
                                return true
                            }else{
                                return false
                            }
                        },
                        componentProps: {},
                        onOk: (component,obj)=>{
                            component.addStory()
                        },
                    },
                    {
                        name: '上传图片',
                        type: 'primary',
                        conditionFun:(record, currentUser)=>{
                            if (!permissionCheck("interview_accept")) {
                                return false;
                            }
                            let data  = record.state.data&&record.state.data.taskReporterObjs?record.state.data.taskReporterObjs:[];
                            let  myRole=data.filter(item=>(item.reporter.name==currentUser.name && item.reporter.account==currentUser.account&&item.reporter.currentDept?.id=== currentUser.defaultInfo?.dept?.id));
                            if(myRole&&myRole.length&&myRole[0].taskRole.indexOf('摄影记者')>-1 && myRole[0].status!=='未领取'){
                                return true
                            }else{
                                return false
                            }
                        },
                        componentProps: {},
                        onOk: (component,obj,call)=>{
                            component.tabsChange('2');
                        },
                    },
                    {
                        name: '上传视频',
                        type: 'primary',
                        conditionFun:(record, currentUser)=>{
                            if (!permissionCheck("interview_accept")) {
                                return false;
                            }
                            let data  = record.state.data&&record.state.data.taskReporterObjs?record.state.data.taskReporterObjs:[]
                            let  myRole=data.filter(item=>(item.reporter.name==currentUser.name && item.reporter.account==currentUser.account&&item.reporter.currentDept?.id=== currentUser.defaultInfo?.dept?.id));
                            if(myRole&&myRole.length&&myRole[0].taskRole.indexOf('摄像记者')>-1 && myRole[0].status!=='未领取'){
                                return true
                            }else{
                                return false
                            }
                        },
                        onOk: (component,obj)=>{
                            component.tabsChange('3');
                        },
                        componentProps: {}
                    },
                ]
            },
            {
                id: 1,
                name: '任务稿件',
                button: null
            },
            {
                id: 2,
                name: '任务图片',
                button: [
                    {
                        component: "taskUpload",
                        type: 'primary',
                        upLoadType: "PIC_TYPE",
                        name:'上传图片',
                        conditionFun:(record, currentUser)=>{
                            if (permissionCheck("interview_accept")) {
                                let data  = record.state.data&&record.state.data.taskReporterObjs?record.state.data.taskReporterObjs:[]
                                let  myRole=data.filter(item=>(item.reporter.name==currentUser.name && item.reporter.account==currentUser.account&&item.reporter.currentDept?.id=== currentUser.defaultInfo?.dept?.id));
                                if(myRole&&myRole.length&&myRole[0].taskRole.indexOf('摄影记者')>-1 && myRole[0].status!=='未领取'){
                                    return true
                                }else{
                                    return false
                                }
                            }else {
                                return false
                            }
                        },
                        onOk: (component,obj,call)=>{
                            if (permissionCheck("interview_accept")) {
                                component.onChange(component,obj,"2")
                            }else {
                                call&&call()
                            }
                        },
                        onUpload: (component,obj) => {
                            if (permissionCheck("interviewTask_creator")) {
                                component.onChange(obj)
                            }
                        }
                    },
                ]

            },
            {
                id: 3,
                name: '任务视频',
                button: [
                    {
                        component: "taskUpload",
                        type: 'primary',
                        upLoadType: "VIDEO_TYPE" ,
                        name:'上传视频',
                        conditionFun:(record, currentUser)=>{
                            if (!permissionCheck("interview_accept")) {
                                return false
                            }else{
                                let data  = record.state.data&&record.state.data.taskReporterObjs?record.state.data.taskReporterObjs:[];
                                let  myRole=data.filter(item=>(item.reporter.name==currentUser.name && item.reporter.account==currentUser.account&&item.reporter.currentDept?.id=== currentUser.defaultInfo?.dept?.id));
                                if(myRole&&myRole.length&&myRole[0].taskRole.indexOf('摄像记者')>-1 && myRole[0].status!=='未领取'){
                                    return true
                                }else{
                                    return false
                                }
                            }
                        },
                        onUpload: (component,obj) => {
                            if (permissionCheck("interviewTask_creator")) {
                                component.onChange(obj)
                            }
                        },
                        onOk: (component,obj,call)=>{
                            if(permissionCheck("interview_accept")){
                                component.onChange(component,obj,"3")
                            }else {
                                call&&call()
                            }
                        },
                    },
                ]

            }
        ]
    },
    "receiverTask": {
        "param": {
            "num": 1,
            "size": 10,
            "keyword": '',
            "keywordFiled": ["taskObj.title", "taskObj.publisher.userName"],
            "showRef": [
                "taskId"
            ],

            "params": [{
                   "key": "reporter.currentDept.id",
                      "opt": "eq",
                       "val": "${window.top.currentUser.defaultInfo.dept.id}",
                 },
                {
                    "key": "taskObj.status",
                    "opt": "ne",
                    "val": "草稿"
                },
                {
                    "key": "reporter.account",
                    "opt": "eq",
                    "val": "${window.top.currentUser.account}"

                }
            ]
        },
        "url": '/cm-sites-business/bd/busTaskReporter/page',
        "columns": [
            {
                "title": '任务名称',
                "dataIndex": 'taskObj.title',
                "ellipsis": true,
                "width":380,
                "renderComponent": "${renderExtend.normalTitle}"
            },
            {
                "title": '任务地点',
                "dataIndex": 'taskObj.place',
                "ellipsis": true,
                "renderComponent": "${renderExtend.normalTitle}"
            },
            {
                "title": '创建时间',
                "dataIndex": 'createTime',
                "renderComponent": "${renderExtend.taskTime}"
            },
            {
                "title": '任务时间',
                "dataIndex": 'taskObj.startTime',
                "width": 300,
                "ellipsis": true,
                "renderComponent": "${renderExtend.InterviewTime}"
            },
            {
                "title": '状态',
                "dataIndex": 'status',
                "renderComponent": "${renderExtend.normalStatus}"

            },
            {
                "title": '操作',
                "dataIndex": 'address',
                "renderComponent": "${renderExtend.normalOperation}"
            }
        ],
        "listOpBtns": [
            {
                "name": "查看",
                "condition": [
                    "已提交",
                    "进行中",
                    "已完成",
                    "未领取",

                ],
                "onOk": "${component.receiverView}"
            }
        ],
        TableList: [
            {
                id: 0,
                name: '任务信息',
                button: [
                    {
                        name: '取消',
                        type: '',
                        condition:["未领取","已领取","进行中"],
                        onOk: (component)=>{
                            component.close()
                        },
                        conditionFun:(record, currentUser)=>{
                            return true
                        },
                    },
                    {
                        name: '领取任务',
                        type: 'primary',
                        onOk: (record)=>{
                            let data  = record.state.data&&record.state.data.taskReporterObjs?record.state.data.taskReporterObjs:[];
                            let  myRole=data.filter(item=>(item.reporter.name==window.currentUser.name && item.reporter.account==window.currentUser.account&&item.reporter.currentDept?.id===window.currentUser.defaultInfo?.dept?.id));
                             record.receiveTask(myRole)
                        },
                        conditionFun:(record, currentUser)=>{
                            let data  = record.state.data&&record.state.data.taskReporterObjs?record.state.data.taskReporterObjs:[]
                            let  myRole=data.filter(item=>(item.reporter.name==currentUser.name && item.reporter.account==currentUser.account&&item.reporter.currentDept?.id=== currentUser.defaultInfo?.dept?.id));
                            if(myRole&&myRole.length&&myRole[0].status==='未领取'){
                                return true
                            }else{
                                return false
                            }
                        },
                    },
                    {
                        name: '去写稿',
                        type: 'primary',
                        conditionFun:(record, currentUser)=>{
                            let data  = record.state.data&&record.state.data.taskReporterObjs?record.state.data.taskReporterObjs:[];
                            let  myRole=data.filter(item=>(item.reporter.name==currentUser.name && item.reporter.account==currentUser.account&&item.reporter.currentDept?.id=== currentUser.defaultInfo?.dept?.id));
                            if(myRole&&myRole.length&&myRole[0].taskRole.indexOf('文字记者')>-1 && myRole[0].status!=='未领取' && myRole[0].status!=='已完成'){
                                return true
                            }else{
                                return false
                            }
                        },
                        componentProps: {},
                        onOk: (component,obj)=>{
                            component.addStory()
                        },
                    },
                    {
                        name: '上传图片',
                        type: 'primary',
                        conditionFun:(record, currentUser)=>{
                            let data  = record.state.data&&record.state.data.taskReporterObjs?record.state.data.taskReporterObjs:[];
                            let  myRole=data.filter(item=>(item.reporter.name==currentUser.name && item.reporter.account==currentUser.account&&item.reporter.currentDept?.id=== currentUser.defaultInfo?.dept?.id));
                            if(myRole&&myRole.length&&myRole[0].taskRole.indexOf('摄影记者')>-1 && myRole[0].status!=='未领取'){
                                return true
                            }else{
                                return false
                            }
                        },
                        componentProps: {},
                        onOk: (component,obj,call)=>{
                            component.tabsChange('2');
                        },
                    },
                    {
                        name: '上传视频',
                        type: 'primary',
                        conditionFun:(record, currentUser)=>{
                            let data  = record.state.data&&record.state.data.taskReporterObjs?record.state.data.taskReporterObjs:[]
                            let  myRole=data.filter(item=>(item.reporter.name==currentUser.name && item.reporter.account==currentUser.account&&item.reporter.currentDept?.id=== currentUser.defaultInfo?.dept?.id));
                            if(myRole&&myRole.length&&myRole[0].taskRole.indexOf('摄像记者')>-1 && myRole[0].status!=='未领取'){
                                return true
                            }else{
                                return false
                            }
                        },
                        onOk: (component,obj)=>{
                            component.tabsChange('3');
                        },
                        componentProps: {}
                    },
                ]
            },
            {
                id: 1,
                name: '稿件列表',
                button: null
            },
            {
                id: 2,
                name: '任务图片',
                button: [
                    {
                        component: "taskUpload",
                        type: 'primary',
                        upLoadType: "PIC_TYPE",
                        name:'上传图片',
                        conditionFun:(record, currentUser)=>{
                            let data  = record.state.data&&record.state.data.taskReporterObjs?record.state.data.taskReporterObjs:[]
                            let  myRole=data.filter(item=>(item.reporter.name==currentUser.name && item.reporter.account==currentUser.account&&item.reporter.currentDept?.id=== currentUser.defaultInfo?.dept?.id));
                            if(myRole&&myRole.length&&myRole[0].taskRole.indexOf('摄影记者')>-1 && myRole[0].status!=='未领取'){
                                return true
                            }else{
                                return false
                            }
                        },

                        componentProps: {},
                        onOk: (component,obj)=>{
                            component.onChange(component,obj)
                        },
                    },
                ]
            },
            {
                id: 3,
                name: '任务视频',
                button: [
                    {
                        component: "taskUpload",
                        type: 'primary',
                        upLoadType: "VIDEO_TYPE" ,
                        name:'上传视频',
                        conditionFun:(record, currentUser)=>{
                            let data  = record.state.data&&record.state.data.taskReporterObjs?record.state.data.taskReporterObjs:[];
                            let  myRole=data.filter(item=>(item.reporter.name==currentUser.name && item.reporter.account==currentUser.account&&item.reporter.currentDept?.id=== currentUser.defaultInfo?.dept?.id));
                            if(myRole&&myRole.length&&myRole[0].taskRole.indexOf('摄像记者')>-1 && myRole[0].status!=='未领取'){
                                return true
                            }else{
                                return false
                            }
                        },
                        onOk: (component,obj)=>{
                            component.onChange(component,obj)
                        },

                    },
                ]
            }
        ]
    }


};
